// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable no-unused-vars, import/no-webpack-loader-syntax */
import Vue from 'vue';
import 'expose-loader?axios!axios';
import _ from 'lodash';
import BootstrapVue from 'bootstrap-vue';
import 'expose-loader?moment!moment';
// eslint-disable-next-line
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueAnalytics from 'vue-analytics';
import App from './App';
import router from './router';

import AxiosGlobal from './plugins/AxiosGlobal';
// import AccountCreate from './components/AccountCreate';
// import FeaturesList from './components/FeaturesList';
// import FeaturesListItem from './components/FeaturesListItem';
// import FeaturesListItemDetails from './components/FeaturesListItemDetails';
// import BarcodeDisplay from './components/BarcodeDisplay';
// import BarcodeInput from './components/BarcodeInput';
// import SignIn from './components/SignIn';
// import SignOut from './components/SignOut';
import AppHeader from './components/AppHeader';

// Vue.component(AccountCreate);
// Vue.component('eh-features-list', FeaturesList);
// Vue.component(FeaturesListItem);
// Vue.component(FeaturesListItemDetails);
// Vue.component(BarcodeDisplay);
// Vue.component(BarcodeInput);
// Vue.component(SignIn);
// Vue.component(SignOut);
Vue.component('app-header', AppHeader);

Vue.use(AxiosGlobal);
Vue.use(BootstrapVue);
Vue.use(VueAnalytics, {
  id: 'UA-83025573-1',
  checkDuplicatedScript: true,
  router,
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js